import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";


type WorkStep = {
  readonly image: string;
  readonly title: string;
  readonly description: string;
};

const workSteps: readonly WorkStep[] = [
  {
    image: "/hw-configure.png",
    title: "Configure",
    description:
      "We align Bravo to your goals, your audience, and your compliance requirements — setting the tone, guardrails, and triggers that matter to you.",
  },
  {
    image: "/hw-brand.png",
    title: "Brand",
    description:
      "Your logo, your colors, your domain. Every user touchpoint reflects your brand — Bravo powers the experience invisibly.",
  },
  {
    image: "/hw-deploy.png",
    title: "Deploy",
    description:
      "Go live across your existing apps, portals, and platforms with minimal development effort — in weeks, not months.",
  },
  {
    image: "/hw-grow.png",
    title: "Grow",
    description:
      "Conversations generate real-time signals — giving your team visibility into user needs, engagement trends, and emerging opportunities.",
  },
] as const;

export const HowItWorksSection: React.FC = () => {
  return (
    <section id="how-it-works" className="bg-primary-700 w-full">
      <div className="section-inset pt-12 pb-12 md:py-20">
        <div className="mb-8 md:mb-14">
          <SectionHeader
            label="How It Works"
            heading="From integration to impact in days, not months."
            description="Bravo is designed for fast deployment — get up and running quickly so you can start delivering value to your users and your business."
            theme="dark"
          />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
          {workSteps.map((step) => (
            <div
              key={step.title}
              className="hw-card flex w-full flex-col gap-4 rounded-2xl bg-white p-6"
            >
              <img
                src={step.image}
                loading="lazy"
                alt=""
                className="h-36 w-36 self-center object-contain"
              />

              <div className="flex flex-col gap-4">
                <h4 className="subtitle-b-bold text-black">{step.title}</h4>

                <p className="body-b-regular text-black">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
